/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import Dropdown from '../../../components/Dropdown'
import { useRef, useState } from 'react'
import CustomDatePicker from '../../../components/DatePicker'
import dayjs from 'dayjs'



export default function FilterBtn({ dateError, setdateError, isFilterOpen, setIsFilterOpen, handleApplyFilter, initialState, filterValues, setFilterValues, handleOpenFilter }) {

    function handleSelectDate(id, date, dateString, termkey) {
        if (id === "filter_start_date") {
            setFilterValues((prv) => ({
                ...prv,
                start_date: dateString,
            }));
        }
        else {
            setFilterValues((prv) => ({
                ...prv,
                end_date: dateString,
            }));
        }

    }

    const handleCheck = () => {
        if ((dayjs(filterValues?.end_date).isBefore(dayjs(filterValues?.start_date))) && (filterValues?.end_date !== undefined && filterValues.start_date !== undefined)) {
            return true
        }
        return false
    }

    return (
        <div className='xl:relative ml-2.5 2xl:mb-0 mb-2.5'>
            <button id='filter' type='button' className='flex items-center border border-[#972E4C] rounded-[15px] px-4 py-2' onClick={handleOpenFilter}>
                <img src="/images/filter_icon.svg" alt="icon" />
                <span className='text-lg font-semibold text-[#972E4C] ml-2.5'>Filter</span>
            </button>
            {
                isFilterOpen &&

                <div className=' absolute top-[110px] tp:top-[62px] xl:top-14 filter_top right-0 xl:left-[-195px] left-auto bg-white rounded-[15px] border border-[#D296B2] px-2.5 pt-4 py-[26px] shadow-s2 w-[454px] z-[99]'>
                    <div className='flex justify-between items-center mb-2'>
                        <p className='text-sm font-semibold text-[#52555D]'>Filter by:</p>
                        {dateError && <p className="text-xs text-red-500 mt-2 mr-8">Please select the valid date range.</p>}
                        <button type='button' onClick={() => { setIsFilterOpen(!isFilterOpen), setdateError(false) }}>
                            <img src="/images/cross_mark_gray.svg" alt="icon" />
                        </button>
                    </div>
                    <div className='flex justify-between'>
                        <p className='text-[#000000] rounded-lg cursor-pointer text-end text-[12px] font-semibold'> Created Date</p>
                        {/* <p  onClick={() => { handleApplyFilter(false); setdateError(false); setFilterValues(initialState); setIsFilterOpen(false); }}
                                id="Cancel"
                                className={`rrounded-lg cursor-pointer text-end text-[12px] font-semibold text-[#972E4C] ml-auto ${Object.values(filterValues).every(value => typeof value === 'string' && value.trim() === ''||value===undefined)? 'hidden' : 'ml-auto'
                                }`}
                            >
                                Clear All
                            </p> */}

                    </div>
                    <div className='flex flex-wrap -mx-2'>
                        <div className='w-1/2 px-2 mb-4'>
                            <div className='w-full'>
                                <CustomDatePicker
                                    id={"filter_start_date"}
                                    classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                                    format="MMM DD, YYYY"
                                    state={filterValues}
                                    placeholder={"Select start date"}
                                    label={"Start Date"}
                                    termkey={filterValues?.start_date}
                                    handleSelect={handleSelectDate}
                                    imageClass={true}
                                    setdateError={setdateError}
                                // disabledFutureDate={true}
                                />
                            </div>
                        </div>
                        <div className='w-1/2 px-2 mb-4'>
                            <div className='w-full'>
                                <CustomDatePicker
                                    label={"End Date"}
                                    classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                                    placeholder={"Select end date"}
                                    format="MMM DD, YYYY"
                                    state={filterValues}
                                    termkey={filterValues?.end_date}
                                    handleSelect={handleSelectDate}
                                    id={"filter_end_date"}
                                    setdateError={setdateError}
                                // disabledFutureDate={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex mt-[13px] justify-between">
                        <button type="button" id="Cancel" onClick={() => { handleApplyFilter(false); setdateError(false); setFilterValues(initialState); setIsFilterOpen(false); }} class="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-lg font-semibold text-[#972E4C]">
                            Clear All
                        </button>

                        <button
                            onClick={() => {
                                if (handleCheck()) {
                                    setdateError(true)
                                    return
                                }
                                handleApplyFilter(true), setIsFilterOpen(false)
                            }}
                            type='button'
                            id="apply-filter"
                            disabled={Object.values(filterValues).every(value => typeof value === 'string' && value.trim() === '')}
                            className={`py-2.5 text-lg px-8 rounded-[16px]  ${Object.values(filterValues).every(value => typeof value === 'string' && value.trim() === '' || value === undefined) ? 'bg-[#777C88]' : 'bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] border border-[#972E4C]'}    font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                            Apply
                        </button>
                    </div>
                </div>
                // </motion.div>
            }
        </div>
    )
}